import React from 'react';

import router from 'next/router';

import { PrimaryButton } from '@/components/Button/PrimaryButton';

const ConnectedUser = ({ tokenName }: any) => {
  return (
    <div className="">
      <div className="pt-4">
        <p className="flex justify-center">
          {`Try to connect with another wallet with ${tokenName}`}
        </p>
        <div className="flex justify-center p-1 font-semibold">Or</div>
      </div>
      <div className="">
        <p className="flex justify-center">Fileverse is free, try it!</p>
        <p className="text-center ">
          We are an open source file-sharing app for web3 communities, anons and
          frens
        </p>
        <div className="flex justify-center mt-4">
          <PrimaryButton onClick={() => router.push('/')}>
            <span className="px-2 font-semibold">Share File</span>
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};

export default ConnectedUser;
